import React, { FC } from 'react';
import { BaseWrapper } from 'styles/common';
import { Phase } from 'types';
import RoadMap from './RoadMap';
import { Container, Description, DescriptionContainer, TextContainer, Title, Bubble7, Bubble8 } from './styled';
import ParallaxImage from 'components/parallax/Parallax';
import { mediaSm } from 'theme/theme-helper-selectors';
import { css } from 'styled-components';
import { sanitize } from 'isomorphic-dompurify';

interface PhasesProps {
    config: {
        title: string;
        description: string;
    };
    phases: Phase[];
    secondary?: boolean;
}

const Phases: FC<PhasesProps> = ({ config: { title, description }, phases }) => (
    <Container id="calendar">
        <ParallaxImage
            src={process.env.PUBLIC_URL + '/assets/images/star.png'}
            alt={'Star'}
            speed={0.1}
            customStyles={css`
                position: absolute;
                top: -165px;
                left: 20%;
                width: 355px;

                @media (${mediaSm}) {
                    display: none;
                }
            `}
        />
        <Bubble8 src={process.env.PUBLIC_URL + `/assets/images/bubble8.png`} alt="Safeboard bubble image" />

        <BaseWrapper styles={{ position: 'relative' }}>
            <Bubble7 src={process.env.PUBLIC_URL + `/assets/images/bubble7.png`} alt="Safeboard bubble image" />
            <TextContainer>
                <Title>{title}</Title>
                <DescriptionContainer>
                    <Description>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: sanitize(description),
                            }}
                        />
                    </Description>
                    <RoadMap phases={phases} />
                </DescriptionContainer>
            </TextContainer>
        </BaseWrapper>
    </Container>
);

export default Phases;
